export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      6923.90022675737,
    ],
    button_spin: [
      8000,
      994.104308390023,
    ],
    end_free_spin: [
      10000,
      3899.501133786849,
    ],
    free_bet_big_win: [
      15000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      18000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      22000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      24000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      27000,
      49171.15646258503,
    ],
    free_spin_appears: [
      78000,
      6253.424036281174,
    ],
    free_spin_music: [
      86000,
      53394.28571428573,
    ],
    free_spin_start: [
      141000,
      10302.403628117901,
    ],
    inside_buttons: [
      153000,
      372.97052154195853,
    ],
    main_ambient: [
      155000,
      84362.44897959182,
    ],
    main_music: [
      241000,
      219885.71428571423,
    ],
    mega_win: [
      462000,
      6950.022675736989,
    ],
    outside_buttons: [
      470000,
      338.14058956915005,
    ],
    reel_spin: [
      472000,
      2713.8321995464594,
    ],
    reel_stop_01: [
      476000,
      158.1859410430866,
    ],
    reel_stop_02: [
      478000,
      187.21088435376032,
    ],
    reel_stop_03: [
      480000,
      169.79591836735608,
    ],
    reel_stop_04: [
      482000,
      193.01587301589507,
    ],
    reel_stop_05: [
      484000,
      216.2358276643772,
    ],
    regular_win: [
      486000,
      1391.7460317460382,
    ],
    tap_to_play: [
      489000,
      5974.784580498863,
    ],
    ultra_win: [
      496000,
      5957.369614512459,
    ],
  },
}
